<div id="header-{{ props.anchorId }}" class="pb-3 header bg-light">
  <h2 class="header-title d-flex col-12">{{ props.heading }}</h2>
  @if (props.rightTitle) {
    <div class="d-flex col-12 info-text mt-3 pl-0">
      {{ props.rightTitle }}
    </div>
  }
</div>
<ng-container #fieldComponent></ng-container>
